// removed by extract-text-webpack-plugin
module.exports = {"ConversationBody":"ConversationBody__2ddlk"};


//////////////////
// WEBPACK FOOTER
// ./routes/Conversations/style.scss
// module id = ICtB
// module chunks = 0